export enum DocumentType {
  RESUME = 'RESUME',
  DIPLOMA = 'DIPLOMA',
  CAREER_CERT = 'CAREER_CERT',
  LICENSE = 'LICENSE',
  SALARY_CONTRACT = 'SALARY_CONTRACT',
  RESIDENT_COPY = 'RESIDENT_COPY',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  PROFILE_PHOTO = 'PROFILE_PHOTO',
  INTRO_PPT = 'INTRO_PPT',
  CONTRACT = 'CONTRACT',
  NDA = 'NDA',
  PRIVACY = 'PRIVACY',
  PROBATION = 'PROBATION',
  EQUIPMENT = 'EQUIPMENT',
  OTHER = 'OTHER'
}

export interface Document {
  id: number;
  originalName: string;
  fileName: string;
  filePath: string;
  fileExtension: string;
  fileSize: number;
  mimeType: string;
  documentType: DocumentType;
  description?: string;
  parentId?: number;
  uploadedBy?: string;
  employeeId: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDocumentRequest {
  documentType: DocumentType;
  description?: string;
}
